import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'nestedProperty'
})
export class NestedPropertyPipe implements PipeTransform {

    transform(obj: any, path: string): any {
        if (!obj || !path) return null;

        return path.split('.').reduce((acc, part) => acc && acc[part], obj);
    }

}
